import { getGuidsToSkip } from '@thoughtspot/session-service';
import { useCallback, useEffect, useRef, useState, } from 'react';
export function usePaginatedList({ page, isLastBatch, loading, resetKey, batchSize, offset, setOffset, }) {
    const [items, setItems] = useState([]);
    const prevResetKey = useRef(resetKey);
    const loadPending = useRef(false);
    const lastPage = useRef();
    if (prevResetKey.current !== resetKey) {
        prevResetKey.current = resetKey;
        setOffset(0);
        setItems([]);
        lastPage.current = undefined;
    }
    useEffect(() => {
        if (!loading)
            loadPending.current = false;
        if (!page || page === lastPage.current)
            return;
        lastPage.current = page;
        setItems(prev => {
            if (offset === 0) {
                const unchanged = prev.length === page.length &&
                    prev.every((item, idx) => item.id === page[idx].id);
                return unchanged ? prev : page;
            }
            const seen = new Set(prev.map(item => item.id));
            const added = page.filter(item => !seen.has(item.id));
            return added.length ? [...prev, ...added] : prev;
        });
    }, [page, loading, offset]);
    const hasMore = isLastBatch === false;
    const loadMore = useCallback(() => {
        if (loadPending.current || loading || !hasMore)
            return;
        loadPending.current = true;
        setOffset(prev => prev + batchSize);
    }, [loading, hasMore, batchSize, setOffset]);
    return { items, hasMore, loadMore };
}
export function mergeSeedItems(fetched, seeds, searchText) {
    if (searchText.trim() || !seeds.length)
        return fetched;
    const seedIds = new Set(seeds.map(seed => seed.id));
    return [...seeds, ...fetched.filter(item => !seedIds.has(item.id))];
}
export function toSeedItems(candidates) {
    const hiddenGuids = new Set(getGuidsToSkip());
    return candidates
        .map(candidate => ({
        id: candidate?.id ?? '',
        name: candidate?.name ?? '',
    }))
        .filter(seed => seed.id && !hiddenGuids.has(seed.id));
}
//# sourceMappingURL=use-paginated-list.js.map